var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lee-echarts',{style:({height:_vm.height,width:_vm.width}),attrs:{"options":_vm.option,"autoresize":"","theme":"lenglian"}})
}
var staticRenderFns = []

export { render, staticRenderFns }